/* eslint-disable no-param-reassign */
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import transform from 'lodash/transform';

export function differenceBetweenObjects<T extends object>(obj1: T, obj2: T): Partial<T> {
  return transform(obj1, (result, value, key) => {
    if (!isEqual(value, obj2[key])) {
      if (isObject(value) && isObject(obj2[key])) {
        // @ts-ignore Due to the dymanic nature of this function TS is not sure about correctness of types.
        result[key] = differenceBetweenObjects(value, obj2[key]);
      }
      result[key] = value;
    }
  });
}

export function isInteger(value: number): boolean {
  return value % 1 === 0;
}

